<template>
    <div class="home-main">
        <!-- 卫星选项 -->
        <div class="home-main-bottom" > 
          <div class="home-main-bottom_tab_desc">
            <p class="home-main-bottom_tab_group-li-title">FengYun Meteorological satellites</p>
            <div class="home-main-bottom_tab_group" v-for="(item, index) in menuInfo" :key="index" >
              <div class="home-main-bottom_tab_group-li" v-for="(val, idx) in item.children" :key="idx + idx" @click="clickTab(val.satName)">
                <div class="home-main-bottom_tab_sat" :title="val.satName + ' ' + (index == 0 ? 'Resolution' : 'Position') + ': ' + val.resolution">
                  <span class="satImg" :class="active == val.satName ? 'satActive' : ''" >
                    <img :src="val.icon" :class="'satIcon'+index"/>
                  </span>
                  <span class="satName">{{val.satName}}</span>
                  <span class="resolution">{{ val.type }}:</span>
                  <!-- <span class="resolution">{{ index == 0 || index == 1 ? 'Resolution' : 'Position' }}:</span> -->
                  <span>{{val.resolution}}</span>
                  <!-- <span class="proName">{{ index == 0 ? 'Products' : 'Service' }}:</span>
                  <span>{{val.products}}</span> -->
                </div>
              </div>
            </div>
          </div>
        </div>

        <div id="home-map" style="position: relative; z-index: 100">
          <div class="sat3d" v-show="active == 'FY-3D'">
            <!-- <div style="position: absolute; left: 0; right: 0; top:0; bottom: 0; margin: auto:text-align: center; padding:0.1rem; box-sizing: border-box;">style="    text-align: center;
    margin: auto;" -->
              <img :src="apiImage3d" >
            <!-- </div> -->
            
          </div>
          <div class="sat2h" v-show="active == 'FY-2H'">
            <img :src="apiImage2h1">
          </div>
          <div class="sat4a" v-show="active == 'FY-3F'">
            <img :src="apiImage3f">
          </div>
          <div class="sat4b" v-show="active == 'FY-4B'">
            <div class="sat4bBox">
              <img :src="apiImage4b1" />
            </div>
            <div class="sat4bBox">
              <img :src="apiImage4b2" />
            </div>
          </div>
        </div>        
    </div>
</template>
<script>
    export default {
        name: 'App',
        data () {
            return {
                active: 0,
                menuInfo: window.fyEarth.home_satInfo,
                apiImage3d: '',
                apiImage2h1: '',
                apiImage2h2: '',
                apiImage4a1: '',
                apiImage4a2: '',
                apiImage4b1: '',
                apiImage4b2: '',
                apiImage3f: '',
                satImgInfo: window.fyEarth.home_satImgInfo,
            }
        },
        created() {
            let homeSatId = localStorage.getItem('home-satName') || this.menuInfo[0].children[0].satName
            // let homeSatId = this.menuInfo[0].children[0].satName
            this.clickTab(homeSatId)
        },
        methods: {
            clickTab(satName){
                localStorage.setItem('home-satName', satName)
                this.active = satName
                // this.apiImage3d = ''
                // this.apiImage4a1 = ''
                // this.apiImage4a2 = ''
                // this.apiImage2h1 = ''
                // this.apiImage2h2 = ''
                if(satName == 'FY-3D'){
                    this.apiImage3d = this.satImgInfo.apiImage3d
                } 
                // else if(satName == 'FY-4A'){
                //     this.apiImage4a1 = this.satImgInfo.apiImage4a1
                //     this.apiImage4a2 = this.satImgInfo.apiImage4a2
                // } 
                else if(satName == 'FY-2H'){
                    this.apiImage2h1 = this.satImgInfo.apiImage2h1
                    this.apiImage2h2 = this.satImgInfo.apiImage2h2
                } else if(satName == 'FY-4B'){
                    this.apiImage4b1 = this.satImgInfo.apiImage4b1
                    this.apiImage4b2 = this.satImgInfo.apiImage4b2
                } else if(satName == 'FY-3F'){
                    this.apiImage3f = this.satImgInfo.apiImage3f
                    // this.apiImage4b2 = this.satImgInfo.apiImage4b2
                }
            },
        }
    }
</script>
<style scoped>
</style>
<script>
    export default {
        name: 'App',
        data () {
            return {
                active: 0,
                menuInfo: window.fyEarth.home_satInfo,
                apiImage3d: '',
                apiImage2h1: '',
                apiImage2h2: '',
                apiImage4a1: '',
                apiImage4a2: '',
                apiImage4b1: '',
                apiImage4b2: '',
                apiImage3f: '',
                satImgInfo: window.fyEarth.home_satImgInfo,
            }
        },
        created() {
            let homeSatId = localStorage.getItem('home-satName') || this.menuInfo[0].children[0].satName
            // let homeSatId = this.menuInfo[0].children[0].satName
            this.clickTab(homeSatId)
        },
        methods: {
            clickTab(satName){
                localStorage.setItem('home-satName', satName)
                this.active = satName
                // this.apiImage3d = ''
                // this.apiImage4a1 = ''
                // this.apiImage4a2 = ''
                // this.apiImage2h1 = ''
                // this.apiImage2h2 = ''
                if(satName == 'FY-3D'){
                    this.apiImage3d = this.satImgInfo.apiImage3d
                } 
                // else if(satName == 'FY-4A'){
                //     this.apiImage4a1 = this.satImgInfo.apiImage4a1
                //     this.apiImage4a2 = this.satImgInfo.apiImage4a2
                // } 
                else if(satName == 'FY-2H'){
                    this.apiImage2h1 = this.satImgInfo.apiImage2h1
                    this.apiImage2h2 = this.satImgInfo.apiImage2h2
                } else if(satName == 'FY-4B'){
                    this.apiImage4b1 = this.satImgInfo.apiImage4b1
                    this.apiImage4b2 = this.satImgInfo.apiImage4b2
                } else if(satName == 'FY-3F'){
                    this.apiImage3f = this.satImgInfo.apiImage3f
                    // this.apiImage4b2 = this.satImgInfo.apiImage4b2
                }
            },
        }
    }
</script>
<style scoped>
</style>